<template>
    <div v-if="dataForm.step == '04'" class="certificate-four-step">
        <div class="el-message-box__wrapper"  v-if="isShowMessage">
            <div class="el-message-box">
                <div class="el-message-box__header">
                    <div class="el-message-box__title">
                        <span>温馨提示</span>
                    </div>
                </div>
                <div class="el-message-box__content">
                    <div class="el-message-box__message">
                        <p>企业认证将用时约2分钟，认证过程需要获取您的部分个人信息，我们郑重承诺将严格保密客户的所有信息！</p>
                    </div>
                </div>
                <div class="el-message-box__btns">
                    <el-button type="button" @click="goEWallet" style="padding: 7px 15px" :loading="isloading" class="el-button--primary ">
                        <span>同意继续</span>
                    </el-button>
                    <el-button type="button" @click="backToStep"  style="padding: 7px 15px; width: auto" :loading="isloading">
                        <span>返回报价信息</span>
                    </el-button>
                </div>
            </div>
        </div>
        <div :style="{height: screenHeight - 280 + 'px'}">
            <iframe :src="parameUrl" frameborder="0" class="is-iframe"></iframe>
        </div>
        <div class="Tips" v-if="parameUrl">
            <p>温馨提示：个人认证的手机号码和注册时一致,</p>
            <p>需为运营商实名登记的手机号。</p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isloading: false,
            parameUrl: '',
            screenHeight: '',
            isWarning: true
        }
    },
    props: {
        dataForm: {
            type: Object,
            defualt: {}
        }
    },
    computed: {
        isShowMessage: {
            get: function () {
                if (this.dataForm.step == '04' && this.isWarning) {
                    return true
                } else {
                    return false
                }
            }
        }
    },
    watch: {
        // 'dataForm.step':{
        //     handler (val) {
        //         if (val == '04') {
                    
        //             this.goEWallet()
                    
        //         }
        //     },
        //     immediate: true
        // }
    },
    mounted () {
        this.screenHeight = window.screen.height
    },
    methods: {
        backToStep () {
            this.isloading = true
            sessionStorage.removeItem("firstIn");
            this.$parent.backToStep('03').then(() => {
            }).finally(() => {
                this.isloading = false
            })
        },
        goEWallet () {
            this.isloading = true
            this.$get('/bas/client/basCustomer/getInfoByQichacha', {companyName: this.dataForm.enterpriseName}).then(({data}) => {
                if (data && data.code == 'C0000') {
                    this.sendData('/sys/esignEnterprise/add', {name: this.dataForm.enterpriseName, uscCode: data.result.CreditCode})
                }
            })
            
        },
        sendData (url, obj) {
            this.$post(url, obj).then(({data}) => {
                if (data && data.code == 'C0000') {
                    this.parameUrl = data.result
                } else if (data.code == 'E0000' && data.message == '当前企业已认证成功,请勿重复操作') {
                    let obj = Object.assign({}, {step: '05'})
                    this.$parent.gotoStep(obj).then(() => {}).finally(() => {
                    })
                }
            }).finally(() => {
                this.isWarning = false
                this.isloading = false
            })
        }
    },
}
</script>

<style lang="scss">
.certificate-four-step {
    .is-iframe {
        width: 100%;
        height: 100%;
    }
    .Tips{
        border: 1px solid #ccc;
        border-radius: 6px;
        box-shadow: 0px 0px 20px #ccc;
        width: 300px;
        line-height: 20px;
        padding: 6px;
        position: fixed;
        bottom: 100px;
        right: 70px;
        font-size: 14px;
    }
}
</style>